"use strict";
/**
 * Abstract cache storage
 */
var CacheStorageAbstract = (function () {
    function CacheStorageAbstract() {
    }
    return CacheStorageAbstract;
}());
exports.CacheStorageAbstract = CacheStorageAbstract;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-cache-service/dist/src/services/storage/cache-storage-abstract.service.js
// module id = 246
// module chunks = 3